import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class EncryptionService {
    private encryptionKey!: CryptoKey;

    constructor() { }

    private async initEncryptionKey() {
        const keyData = new TextEncoder().encode('13ssyst3msocr1av3rt3xg3m1n128ehz'); // misma clave que en Python
        this.encryptionKey = await window.crypto.subtle.importKey(
            'raw',
            keyData,
            { name: 'AES-GCM' },
            false,
            ['encrypt', 'decrypt']
        );
    }

    async encrypt(data: string): Promise<string> { // Retornar como string Base64
        if (!this.encryptionKey) {
            await this.initEncryptionKey();
        }
        const encodedData = new TextEncoder().encode(data);
        const nonce = window.crypto.getRandomValues(new Uint8Array(12));
        const ciphertext = new Uint8Array(await window.crypto.subtle.encrypt(
            { name: 'AES-GCM', iv: nonce },
            this.encryptionKey,
            encodedData
        ));

        const combined = this.concatUint8Arrays(nonce, ciphertext);
        return this.arrayBufferToBase64(combined);
    }

    async decrypt(data: string): Promise<any> { // Recibir como string Base64
        console.log('Data----------:', data);
        if (!this.encryptionKey) {
            await this.initEncryptionKey();
        }
        const combined = this.base64ToUint8Array(data);
        const nonce = combined.slice(0, 12);
        const ciphertext = combined.slice(12);

        try {
            const plaintext = await window.crypto.subtle.decrypt(
                { name: 'AES-GCM', iv: nonce },
                this.encryptionKey,
                ciphertext
            );
            const decodedText = new TextDecoder().decode(plaintext);
            //console.log('Decrypted:', JSON.stringify(decodedText));
            return JSON.parse(decodedText);
        } catch (error) {
            console.error('Decryption error:', error);
            throw new Error('Failed to decrypt response.');
        }
    }

    private concatUint8Arrays(a: Uint8Array, b: Uint8Array): Uint8Array {
        const c = new Uint8Array(a.length + b.length);
        c.set(a, 0);
        c.set(b, a.length);
        return c;
    }

    private arrayBufferToBase64(buffer: Uint8Array): string {
        let binary = '';
        const len = buffer.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(buffer[i]);
        }
        return btoa(binary);
    }

    private base64ToUint8Array(base64: string): Uint8Array {
        const binary = atob(base64);
        const len = binary.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
    }
}